// @flow
import {
  FETCH_SEARCH_RESULTS_LOADING,
  FETCH_SEARCH_RESULTS_SUCCESS,
  FETCH_SEARCH_RESULTS_ERROR,
  FETCH_SEARCH_RESULTS_ADVANCED_LOADING,
  FETCH_SEARCH_RESULTS_ADVANCED_SUCCESS,
  FETCH_SEARCH_RESULTS_ADVANCED_ERROR,
  FETCH_SEARCH_RESULTS_FOR_UPDATES_SUCCESS,
  FETCH_SEARCH_RESULTS_FOR_UPDATES_ADVANCED_SUCCESS,
} from '../actions/searchActions';

// searchData is an array of patients corresponding to a search from the search page
// updatesData is an array of patients corresponding to a search from the updates page
const initialState = {
  searchData: [],
  updatesData: [],
};

export default (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case FETCH_SEARCH_RESULTS_LOADING:
    case FETCH_SEARCH_RESULTS_ADVANCED_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case FETCH_SEARCH_RESULTS_SUCCESS:
    case FETCH_SEARCH_RESULTS_ADVANCED_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        searchData: action.data,
      };
    case FETCH_SEARCH_RESULTS_ERROR:
    case FETCH_SEARCH_RESULTS_ADVANCED_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    case FETCH_SEARCH_RESULTS_FOR_UPDATES_SUCCESS:
    case FETCH_SEARCH_RESULTS_FOR_UPDATES_ADVANCED_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        updatesData: action.data,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/searchReducer.js